import gql from 'graphql-tag';

export const MODIFY_CREDIT_CARD = gql`
  mutation ($policyId: ID!, $accountId: ID!, $basisTheoryCardToken: String!, $customerId: String!) {
    creditCard: modifyCreditCard(
      accountId: $accountId
      policyId: $policyId
      basisTheoryCardToken: $basisTheoryCardToken
      customerId: $customerId
    ) {
      last4
      brand
      id
      expMonth
      expYear
    }
  }
`;

export const ADD_CREDIT_CARD = gql`
  mutation ($policyId: ID!, $accountId: ID!, $basisTheoryCardToken: String!, $customerId: String, $isPrimary: Boolean) {
    addCreditCard(
      accountId: $accountId
      policyId: $policyId
      basisTheoryCardToken: $basisTheoryCardToken
      customerId: $customerId
      isPrimary: $isPrimary
    ) {
      success
      message
      card {
        id
        last4
        brand
        expMonth
        expYear
        customerId
      }
    }
  }
`;

export const RUN_MANUAL_CHARGE = gql`
  mutation (
    $policyId: ID!
    $accountId: ID!
    $paymentMethod: String!
    $amount: Float!
    $internalDescription: String!
    $billType: String!
    $payAhead: Boolean
  ) {
    runManualCharge(
      policyId: $policyId
      accountId: $accountId
      paymentMethod: $paymentMethod
      amount: $amount
      internalDescription: $internalDescription
      billType: $billType
      payAhead: $payAhead
    ) {
      last4
      type
      success
      error
    }
  }
`;

export const REMOVE_PAYMENT_METHOD = gql`
  mutation ($paymentMethodId: ID!, $accountId: ID!, $policyId: ID!) {
    removePaymentMethod(paymentMethodId: $paymentMethodId, policyId: $policyId, accountId: $accountId) {
      id
      brand
      last4
      bankName
      expMonth
      expYear
    }
  }
`;
